import "../../stylesheets/about-package/about.less";
import "../../stylesheets/shared-package/shared.less";

import {t} from "@lingui/core/macro";
import {Trans} from "@lingui/react/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {
    withActionScheduler,
    type ITimeout,
    type WithActionSchedulerProps,
    type WithoutActionScheduler,
} from "@khanacademy/wonder-blocks-timing";
import {doNotTranslate} from "@repo/i18n";
import {staticUrl} from "@repo/urls";

import PageRoot from "#app-shell-package/page-root.tsx";
import $ from "#jquery/jquery.ts";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import {withStrings} from "./locales/our-content-specialists/load-strings.tsx";

type OwnProps = Empty;
type Props = OwnProps & WithActionSchedulerProps;

class OurContentSpecialists extends React.Component<Props> {
    // @ts-expect-error - TS2564 - Property 'defaultSearchBarPosition' has no initializer and is not definitely assigned in the constructor.
    defaultSearchBarPosition: number;
    $spacer: any;

    componentDidMount() {
        this.initLayout();
        this.initSearch();
    }

    initLayout() {
        const {schedule} = this.props;
        const $portraitContainer = $(".portrait-container");
        let unhoverTimeout: ITimeout | null | undefined = null;
        // Ensure bottom of the page has enough room to not cut off card info,
        // fade out portraits when any person is hovered
        $("#the-team .team-card").hover(
            function (this: HTMLElement) {
                // eslint-disable-next-line no-invalid-this
                const infoHeight: number = $(this)
                    .children(".card-info")
                    .height();
                const currentPadding: number = parseInt(
                    $(".portrait-container").css("padding-bottom"),
                );
                if (infoHeight > currentPadding) {
                    $(".portrait-container").css("padding-bottom", infoHeight);
                }
                $portraitContainer.addClass("over-team-card");
                if (unhoverTimeout != null) {
                    unhoverTimeout.clear();
                    unhoverTimeout = null;
                }
            },
            function () {
                // Don't remove the class right away because the user is
                // probably just moving the mouse from one card to another
                // and if we remove the class and add it again performance
                // suffers badly.
                if (unhoverTimeout != null) {
                    unhoverTimeout.clear();
                    unhoverTimeout = null;
                }
                unhoverTimeout = schedule.timeout(() => {
                    $portraitContainer.removeClass("over-team-card");
                }, 500);
            },
        );
    }

    initSearch() {
        this.defaultSearchBarPosition = $(".title-section").outerHeight();

        if ($(".title-section").length) {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            this.defaultSearchBarPosition += $(".title-section").offset().top;
        }

        const defaultSearchBarPosition = this.defaultSearchBarPosition;
        // Autofocus on search box when page loads.
        $("#employee-search-box").focus();

        // Search when the user types in the search box.
        $("#employee-search-box").on("input", function (this: HTMLElement) {
            // eslint-disable-next-line no-invalid-this
            const filterFor = $(this).val().toLowerCase();

            // Show all cards that contain the search phrase. Hide cards that
            // don't.
            const $cards = $(".team-card");
            const toShow: Array<Element> = [];
            $cards.each(function (i, elem) {
                const lowerCasedText = $(elem).text().toLowerCase();
                if (
                    filterFor === "" ||
                    lowerCasedText.indexOf(filterFor) >= 0
                ) {
                    toShow.push(elem);
                }
            });

            // Hide all of the cards, *force layout*, then show the ones we
            // want. We do this because otherwise Chrome has a bug in
            // conjunction with -webkit-column-count where the containers don't
            // shrink to the proper height and leave awkward gaps. This seems
            // to fix it. (Doing so resets the scroll position, but that's okay
            // because we're about to set it anyway.)
            $cards.css("display", "none");
            if (document.body) {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                document.body.offsetHeight; // force layout
            }
            $(toShow).css("display", "");

            window.scrollTo(0, defaultSearchBarPosition);
        });
    }

    renderSearchBar: () => React.ReactNode = () => (
        <div className="employee-search">
            <input
                type="text"
                placeholder={t`Search by name or position...`}
                id="employee-search-box"
            />
        </div>
    );

    renderEmeritusFaculty: () => React.ReactNode = () => (
        <div className="domain-humanities">
            <div className="subject-title">
                <h1>{t`Emeritus faculty`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl("/images/headshots/steven2.jpg")}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Steven`}</h2>
                        <p>
                            {t`Steven is an art historian and the co-founder of Smarthistory. As Emeritus Faculty at Khan Academy, he creates, edits and publishes the art history content.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/beth_resized.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Beth`}</h2>
                        <p>
                            {t`Beth is an art historian and the co-founder of Smarthistory. As Emeritus Faculty at Khan Academy, she creates, edits and publishes the art history content.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl("/images/headshots/jay.jpg")}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jay`}</h2>
                        <p>
                            {t`Jay made many of the Chemistry videos on Khan Academy, and he curated the Chemistry content on the site. He has an undergraduate degree in Biochemistry and a graduate degree in Medicine. Jay is also fascinated by art and creates portrait paintings on copper and steel. Drawing pictures of organic molecules allows him to combine his artistic and scientific interests.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderPhysicalSciences: () => React.ReactNode = () => (
        <div className="domain-science">
            <div className="subject-title">
                <h1>{t`Physical Sciences`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/brittany_enzmann.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Brittany Enzmann`}
                        </h2>
                        <h4>{t`Biology`}</h4>
                        <p>
                            {t`Brittany is a biologist with a zeal for both education and research.  She received her Ph.D. in Biology from the University of California, Los Angeles and specializes in the evolution, ecology, and behavior of social insects.  She completed a postdoctoral appointment at Arizona State University, where she investigated the chemosensory abilities of ants and epigenetic effects on ant behavior.  She loves to teach and develop innovative educational materials for biology and environmental science. Brittany also greatly enjoys photography, travel, and chai lattes.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/becky_anderson.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Becky Anderson`}
                        </h2>
                        <h4>{t`Biology`}</h4>
                        <p>
                            {t`Becky is currently pursuing her PhD in Neurosciences at the University of Rhode Island.  Prior to attending URI, she received her BA and MS in Biological Sciences at Dartmouth College and Plymouth State University, respectively. Becky is especially interested in animal behavior; she has previously investigated biological rhythms in horseshoe crabs, and she now studies the neurobiology of aggression in lobsters.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/paul_king.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Paul King`}</h2>
                        <h4>{t`Chemistry`}</h4>
                        <p>
                            <Trans>
                                Paul King is a freelance writer and academic
                                tutor based in New York City. In 2009, he
                                graduated Magna Cum Laude with Honors from the
                                University of Delaware, where he earned his
                                degree in Chemistry. In 2015, he founded his own
                                tutoring company, Paul King Prep LLC. Paul’s
                                work with Khan Academy involves writing and
                                contributing articles on topics in AP Chemistry.
                                You can contact Paul or learn more about him
                                through his website:{" "}
                                <a
                                    href="http://www.paulkingprep.com/"
                                    target="_blank"
                                >
                                    PaulKingPrep.com
                                </a>
                                .
                            </Trans>
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/richard_graham.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Richard Graham`}
                        </h2>
                        <h4>{t`Physics`}</h4>
                        <p>
                            {t`Dr. Graham is an experimental physicist specializing in lasers and atomic physics. Originally from New Zealand, he completed his Ph.D at the University of Canterbury working on the world's largest ring-laser gyroscope — an underground instrument used for precision measurement of earth rotation. Since then he has been working at the University of Washington developing the technology to use individual trapped ions as part of a quantum computer.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderMath: () => React.ReactNode = () => (
        <div className="domain-math">
            <div className="subject-title">
                <h1>{t`Math`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/mike-chicken.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Mike`}</h2>
                        <p>
                            {t`Mike earned a M.Ed. in Secondary Education and spent 11 years teaching theatre and communication classes in Arkansas and Massachusetts before turning his attention to the Internet . He has experience in entrepreneurship, e-commerce, and search engine optimization (SEO). He co-founded a search engine marketing firm and an e-commerce website focused on Southern style called Bourbon &amp; Boots.`}
                        </p>
                        <p>
                            {t`In his spare time he likes to run, swim, read, and tend to his 3 children, 3 dogs, and 7 chickens. All with the help of his beautiful partner and fellow suburban farmer, Susan.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/lisa.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Lisa`}</h2>
                        <p>
                            {t`Lisa is a K-8 Math Specialist in Aventura, Florida who is passionately devoted to helping children and adults make sense of math. She serves on the editorial panel for the National Council of Teachers of Mathematics journal Teaching Children Mathematics and has published problem sets and a research study on visual models in problem solving.`}
                        </p>
                        <p>
                            <Trans>
                                Lisa also presents nationally on Common Core
                                Math and Singapore Math, blogs at{" "}
                                <a href="http://mathspot.net" target="_blank">
                                    mathspot.net
                                </a>{" "}
                                and designs mobile apps for Common Core Math.
                            </Trans>
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/per.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Per`}</h2>
                        <p>
                            {t`Per used to teach math to high-school students in Chicago Public Schools.`}
                        </p>
                        <p>
                            {t`Now, in addition to writing math problems, he teaches math to college students and studies set theory in Berkeley.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/rhonda.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Rhonda`}</h2>
                        <p>
                            {t`Rhonda is Professor Emeritus at Bryn Mawr College, where she taught and did research in mathematics for thirty-one years.`}
                        </p>
                        <p>
                            {t`She also co-founded The EDGE Program (Enhancing Diversity in Graduate Education), which supports women pursuing PhDs in the mathematical sciences.  She served as its Co-Director from 1998-2011.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/sandy.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sandy`}</h2>
                        <p>
                            {t`Sandy has a deep love of teaching math at any level to students, parents, and random people on the street.`}
                        </p>
                        <p>
                            {t`Her favorite Einstein quote is, "If you can't explain it simply, you don't understand it well enough."  Before working at KA, she was an electrical engineer, a high school math teacher, and a tutor for students aged 7 to 70.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/sharon.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sharon`}</h2>
                        <p>
                            {t`Sharon is a teacher to the very core, having taught kids, adults, and adults who teach kids in Bay Area schools.  She relishes doing whatever it takes to help others see the beauty and elegance in math.`}
                        </p>
                        <p>
                            {t`Sharon was drawn to Khan Academy when she started messing with it herself and saw its potential for changing how education happens.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/tara.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Tara`}</h2>
                        <p>
                            {t`Tara is a math teacher at Ben Franklin High School in New Orleans.`}
                        </p>
                        <p>
                            {t`Prior to that, she was living, learning, and teaching in Philadelphia. She earned her M.S. in math education from Drexel.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/liat.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Liat`}</h2>
                        <p>
                            {t`Liat is a certified teacher in Aventura, FL. Through her passion for the arts, she enjoys engaging children in mathematical thinking and helping them develop a love of learning at an early age. Liat has published several problem sets in Teaching Children Mathematics and is also a licensed Zumba instructor.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/gail.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Gail`}</h2>
                        <p>
                            {t`Gail began her career as a 3rd grade teacher in Massachusetts, and since then has taught Kindergarten and first grade.  She has also worked as an ESL teacher for Grades K-4, teaching mostly Kindergarten students.`}
                        </p>
                        <p>
                            {t`Gail has a degree in English and Early Childhood, with a Master's degree in Education.  She finds making math exercises exciting and is happy to be engaging young children in the world of math, especially her two daughters. `}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/brad.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Brad`}</h2>
                        <p>
                            {t`Brad is a teacher and the math department head of Hillside Student Community. Brad majored in physics at the College of Wooster, but his true passions are teaching math and computer science electives. Inspired by Sal and the opencourseware movement, Brad has experimented with flipping his intro programming elective and is currently recording all of his Precalculus lectures for his flipped Precalculus class. He is also pretty fond of rock climbing and geeking-out on Coursera.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/casey.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Casey`}</h2>
                        <p>
                            {t`Casey is the founder of Atlanta's Eclectic Music, where hundreds of kids take music lessons. Casey grew interested in math education after she began the Little Middle School, a homeschool academic program. While myths about talent confront music and math students alike, Casey believes that anyone can succeed with great materials and coaching. She is thrilled to be part of Khan Academy's effort to provide a quality education to millions.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/ben_cohen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ben C.`}</h2>
                        <p>
                            {t`A Virginia boy, Ben graduated from UVA in 2010.  After graduation, he rode his bicycle across the country, volunteered as an English teacher in Honduras, and worked at a rock climbing gym. He then worked as a high school math tutor and became a middle school math teacher for one year. Ben has been a camp counselor for six summers and loves outdoor and athletic activities.  One day he hopes to start his own summer camp.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/sarah.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sarah`}</h2>
                        <p>
                            {t`Sarah’s passion for teaching includes helping students understand math, while developing a love of learning.  Sarah has taught elementary school in both Reno and Las Vegas, Nevada for many years.  Sarah has undergraduate degrees in Elementary and Special Education from the University of Nevada, Reno. She also has a M.Ed. in Curriculum and Instruction from the University of Nevada, Las Vegas. `}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/teri.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Teri`}</h2>
                        <p>
                            {t`Teri loves developing math activities that engage students and help them make sense of math. Along with teaching high school and middle school math, she has helped develop print and digital products for high school and college math courses. Prior to her work with math education, she developed radar and satellite data display programs for a group researching the ionosphere.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/ben_lucki.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ben L.`}</h2>
                        <p>
                            {t`After graduating from Columbia University with a Film Studies degree, Ben remembered that his true passion was for mathematics. He joined the New York City Teaching Fellows and took a post at Brooklyn’s High School of Telecommunication Arts and Technology, where he taught the gamut of high school math courses over eight wonderful years.`}
                        </p>
                        <p>
                            {t`When not writing questions for Khan Academy, Ben enjoys traveling, reading, and playing soccer.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/lori.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Lori`}</h2>
                        <p>
                            {t`Lori is a university instructor in Louisiana. For the past 5 years, she's taught and coordinated freshman-level college algebra and precalculus courses.`}
                        </p>
                        <p>
                            {t`She received her B.S. in Mathematics from the University of Illinois at Urbana-Champaign and her M.S. in Mathematics from Southern Illinois University at Carbondale.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/chris.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Chris`}</h2>
                        <p>
                            {t`Chris is a test prep tutor living in Oakland, California.  He earned a degree in cognitive science from UC Berkeley in 2010.  He also spends his time writing for an education blog and singing in a cappella groups.`}
                        </p>
                        <p>
                            {t`As a tutor, Chris is able to help only those students whose families can afford expensive tutoring, so he is excited to be part of a project that will help bring education to students of all backgrounds.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/brenda.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Brenda`}</h2>
                        <p>
                            {t`A lifelong Southern Illinoisan, Brenda has teaching experience in the Illinois public schools and community college system.  She currently enjoys working with Khan Academy and teaches community college courses.`}
                        </p>
                        <p>
                            {t`She received both her bachelor's and master's degrees from Southern Illinois University at Carbondale.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/duane.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Duane`}</h2>
                        <p>
                            {t`After growing up on an Iowa farm, Duane received a PhD in mathematics from Colorado State University. Duane has been on the mathematics faculty at Loras College and Loyola Marymount University and is currently entering his 28th year as a Lecturer in the Department of Mathematics at the University of California, Davis.`}
                        </p>
                        <p>
                            {t`Duane is an avid bicyclist, international traveler, and goodwill basketball ambassador, and he's been a member of the UC Davis men's basketball coaching staff for 18 years.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/ivan.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ivan`}</h2>
                        <p>
                            {t`Ivan completed his undergraduate studies in Electrical Engineering, then did a M.Sc. in Physics, and a Ph.D. in Computer Science, all at McGill University.`}
                        </p>

                        <p>
                            {t`His research interests include information theory (quantum stuff) and machine learning (data stuff). Ivan has been teaching math and physics for more than 12 years as a private tutor. He recently wrote a math textbook and founded a textbook publishing company.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/ryan.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ryan`}</h2>
                        <p>
                            {t`Ryan hails from North Carolina. He earned his undergraduate degree in Mathematics from Reed College.`}
                        </p>
                        <p>
                            {t`In his free time, he enjoys frustrating video games and playing tennis poorly.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/cloud.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Cloud`}</h2>
                        <p>
                            {t`Cloud grew up in Los Angeles, California. After a stint in Minneapolis, Minnesota researching solar cells, he realized that it gets cold there and moved back to the warmth! Having used Khan Academy in his studies, he feels that everyone should have the opportunity to access quality education.`}
                        </p>
                        <p>
                            {t`Cloud loves the outdoors and tries to climb whenever possible. He also likes tinkering and making things from scratch.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/katie.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Katie`}</h2>
                        <p>
                            <Trans>
                                For nine years Katie taught high school
                                mathematics in public and private schools, and
                                she co-authored{" "}
                                <a
                                    href="https://mathleadershipcorps.org/"
                                    target="_blank"
                                >
                                    Mathematics Learning and Leadership by
                                    Design
                                </a>
                                .
                            </Trans>
                        </p>
                        <p>
                            {t`Katie designs interactive professional learning seminars for math teachers around active sense-making, and she teaches teacher leaders to create partnership coaching relationships with their colleagues.`}
                        </p>
                        <p>
                            {t`Passionate about math education, Katie is currently a doctoral student studying curriculum and instruction.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/kathy.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Kathy`}</h2>
                        <p>
                            <Trans>
                                Devoted to providing excellent mathematics
                                instruction to all students, Kathy has been a
                                leader in math education for over 20 years at
                                the secondary and graduate levels. As the
                                founder and director for Loyola Marymount
                                University’s{" "}
                                <a
                                    href="https://mathleadershipcorps.org/"
                                    target="_blank"
                                >
                                    Mathematics Leadership Corps
                                </a>
                                , Kathy co-authored and teaches the Mathematics
                                Learning and Leadership by Design instructional
                                moves, coaches teacher leaders to be change
                                agents within their organizations, and thrives
                                on the edge of chaos.
                            </Trans>
                        </p>
                        <p>
                            {t`In addition, Kathy currently teaches at a public high school in Los Angeles, California.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`RB`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Ryan Benjamin`}
                        </h2>
                        <p>
                            {t`After writing his undergraduate thesis at Penn on the struggles and barriers that students at West Philadelphia High School faced in successfully completing high school and going on to college, Ryan decided he wanted to further pursue his passion of education. He joined DC Teaching Fellows in 2009 and moved to the nation's capital to teach Math (and be the department chair) at Anacostia High School for three years. He is currently the Director of Data and Assessment at Washington Latin Public Charter School in the District and is also fortunate enough to be Principal of Summer School, teach Geometry and Algebra II, coach the Quiz Bowl team, and play trumpet as part of the student/faculty Jazz Band.`}
                        </p>
                        <p>
                            {t`At Penn, Ryan majored in Urban Studies and Spanish and served on the student government. He also received a Masters of Education in Curriculum and Instruction at American University in 2011. He tutors privately in many areas as well.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/jared_nakamura.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jared Nakamura`}
                        </h2>
                        <p>
                            {t`Jared graduated from Michigan Technological University with a B.S. in Applied Mathematics. While obtaining my degree, I enjoyed working as a tutor for students in physics and grading papers for calculus classes. I am currently studying to become an actuary. I enjoy drawing, writing, and playing piano.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/stacy_beaudoin.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Stacy Beaudoin`}
                        </h2>
                        <p>
                            {t`Stacy has 11 years of experience teaching high school math.  Throughout her teaching career, she developed a love for creating educational activities and assessments.  She has recently acted on this passion and embarked on a career change.  Currently, she works as an assistant editor for for a publishing company and enjoys developing content for the Khan Academy SAT project.  Stacy earned her Bachelors degree from Bowdoin College and her M.S.T. in mathematics from the University of New Hampshire. When not working, Stacy enjoys reading, hiking with her dog and spending time with her nephews.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/matthew_lancellotti.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Matthew Lancellotti`}
                        </h2>
                        <p>
                            {t`Matt is a self-proclaimed mathemaginator.  At Khan Academy, he writes SAT questions and grapples with JavaScript on a daily basis.`}
                        </p>
                        <p>
                            {t`Matt graduated from Rutgers University with a Bachelor of Science in Mathematics and Music.  Matt loves tennis, the violin, and the piano.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/kevin_glynn.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Kevin Glynn`}</h2>
                        <p>
                            {t`After advancing to candidacy for a PhD in Physics at UC Davis, Kevin had a change of heart. He filed for and obtained his Master's Degree, and started teaching high school physics and mathematics in Carver, MA. A long time fan of Khan Academy and a believer in the &ldquo;One World Schoolhouse,&rdquo; Kevin is excited to bring his experience as an engineer, teacher, and physicist&mdash;in both academia and industry&mdash;to students of the world. Kevin is constantly inspired by his wife and six sons and lives in Massachusetts.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/tian_yu_yen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Tian Yu Yen`}</h2>
                        <p>
                            {t`Tian Yu has been excited about teaching math since he was in high school! As an educator in the Denver area, Tian Yu loves to show students that mathematics is both understandable, interesting, and fun! Outside of math, Tian Yu loves to dance and play Capoeira. &ldquo;Berimbau tocou na capoeira. Berimbau tocou, eu vou jogar!&rdquo;`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/fred_chapman.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Fred Chapman`}
                        </h2>
                        <p>
                            {t`Fred is a university professor of mathematics and computer science. He earned his PhD in applied mathematics from the University of Waterloo in Ontario, Canada under the supervision of Keith Geddes, co-inventor of the Maple computer algebra system. In his doctoral thesis, Fred invented a new family of infinite series expansions for multivariate functions, which he named &ldquo;Geddes series&rdquo; in honor of his supervisor. Fred is an expert on mathematical software and a strong advocate of educational technology. He is totally jazzed to be copy editing all of the Khan Academy's math questions!`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/sid.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sid`}</h2>
                        <p>
                            {t`Sid has been a tutor of many subjects for over 10 years in two countries. He is very passionate about making high quality, innovative education available for as many people as possible, and hence loves working at Khan Academy.`}
                        </p>
                        <p>
                            {t`Sid graduated from the University of Chicago with a Bachelors in Mathematics, and also concentrated in Russian. He is an avid programmer and chess player, and enjoys puns and ping pong.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/sulinya.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sulinya`}</h2>
                        <p>
                            {t`Sulinya holds three degrees in engineering and physics from MIT. Growing up, Sulinya loved puzzles, problem solving, and competition math. Her mission is to make mathematics fun and interesting for students to not only help them to excel in it, but to develop a love for the subject as well.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderHumanities: () => React.ReactNode = () => (
        <div className="domain-humanities">
            <div className="subject-title">
                <h1>{t`Humanities`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/melissa_graeber.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Melissa Graeber`}
                        </h2>
                        <p>
                            {t`Melissa majored in English Literature at San Francisco State University, all while designing high school English classes on the side and working with her first students. As an English Department Chair at an alternative high school, she went on to spearhead a complete English curriculum overhaul with an emphasis on inquiry-based, generative learning. Along the way she collaborated with students and teachers alike in developing a college essay writing program and senior capstone projects. Melissa has also worked in the University of California's Office of the President as a High School Articulation Analyst, helping schools state-wide develop and enhance their English curriculum offerings.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/tamra_andrews.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Tamra Andrews`}
                        </h2>
                        <p>
                            {t`Tamra is a freelance item writer and college reference librarian with more than 20 years’ experience creating educational content. She lives in Spicewood, Texas, just outside of Austin, and she performs ongoing work for a number of publishers and test developers that focus on K-12 assessments.  Tamra graduated from the University of Texas at Austin with a bachelor’s degree in English and a master’s degree in library and information science. She wrote astronomy radio scripts for many years and has published books on historical astronomy and sky myths. Her biography and a sketch of her earlier work are published in Something About the Author Volume 129 (and) Contemporary Authors Online (Gale 2002).`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/ali_hedberg.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ali Hedberg`}</h2>
                        <p>
                            {t`Ali received her B.A. in history from Brown University and then began her career teaching middle school in Boston. She has taught 6th  and 8th grade English and history, special education, ESL, and health. She also has experience coaching first-year teachers on best instructional practices. Aside from enjoying teaching, history, and literature, Ali loves to stay active, play with her son, and travel. She is attempting to visit every U.S. national park and section hike the Appalachian Trail.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/rosie_friedland.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Rosie Friedland`}
                        </h2>
                        <p>
                            {t`Rosie earned her B.A. in History from the University of California, Irvine in 2011. She is the Regional Director of Resident Services for a non-profit affordable housing corporation, where she finds and creates resources for residents who need them.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/laura_russell.png",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Laura`}</h2>
                        <p>
                            {t`Laura graduated from New Saint Andrews College with a dual B.A./M.A. in liberal arts and theology, where she served as class whip, was selected as an ISI Honors Fellow, and helped found and coach a local speech and debate club. She subsequently completed an M.S. in Biological Science at LSU-Shreveport, where she was employed as a research assistant to edit manuscripts, grant proposals, and other technical documents. Outside of work and education, her interests include Crossfit, choral music, and experimenting with the combined effects of caffeine and sleep deprivation.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/aaron_laduke.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Aaron LaDuke`}
                        </h2>
                        <p>
                            {t`Aaron started his career in education teaching high school English in rural North Carolina with Teach for America and has gone on to teach literature and writing at public and private high schools and at the community college and university level. He earned a Ph.D. in American literature from Ohio University and currently serves as a lecturer in the department of language and literature at Texas A&amp;M University-Kingsville. Aaron recently spent a year in his home state of North Dakota working in the oil fields of the Bakken shale formation and writing about the current energy boom taking place there.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/michelle_getchell.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Michelle Getchell`}
                        </h2>
                        <h4>{t`US History`}</h4>
                        <p>
                            {t`Michelle Getchell earned her Ph.D. in History at the University of Texas at Austin. Her work has been funded by the Society for Historians of American Foreign Relations and the American Councils for International Education, and has appeared in the Journal of Cold War Studies, Southern California Quarterly, and Beyond the Eagle's Shadow: New Histories of Latin America's Cold War. She has been a postdoctoral fellow in international security and US foreign policy at Dartmouth College, and a visiting fellow at the Kennan Institute of the Woodrow Wilson International Center for Scholars. She teaches history at Shaw University in Raleigh, North Carolina, and is currently working on her first monograph, an examination of US-Soviet-Latin American relations in the Cold War.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/john_louis_recchiuti.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`John Louis Recchiuti`}
                        </h2>
                        <h4>{t`US History`}</h4>
                        <p>
                            {t`John studied at Wesleyan University and at Warwick University, U.K. before earning the doctorate in History at Columbia University. He chairs the history department at University of Mount Union. He has taught at University of Michigan, Columbia University, CCNY and NYU. A member of the National Council for History Education, his 2007 book, Civic Engagement, was nominated for the Bancroft and Parkman prizes.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderTestPrep: () => React.ReactNode = () => (
        <div className="domain-test-prep">
            <div className="subject-title">
                <h1>{t`Test Prep`}</h1>
            </div>
            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/anh-chi_furey.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Anh-Chi Furey`}
                        </h2>
                        <p>
                            {t`Anh-Chi has taught LSAT since 2008 and currently works in the non-profit sector of education to promote equity and inclusion for all students. She lives and golfs in San Diego with her husband and three dogs (not including all of the dogs that visit the doggie daycare center she runs out of her home).`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/danny_coleman.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Danny Coleman`}
                        </h2>
                        <p>
                            {t`Danny spent six years as a full-time test-prep instructor and has worked with over 1500 students in Montreal, Toronto, New York City, and Saudi Arabia. He has 99th percentile scores on the GRE, GMAT, and LSAT. He currently lives in Carbondale, Illinois, where he teaches composition and studies fiction at Southern Illinois University.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/jessica_hendel.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jess Hendel`}</h2>
                        <p>
                            {t`Jess Hendel is a Los Angeles-based writer. She has a BA in Sociology from Amherst College and an MFA in Writing for Screen and Television from USC's School of Cinematic Arts. She's worked for many years as a tutor and educational content writer.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/annie_hollister.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Annie Hollister`}
                        </h2>
                        <p>
                            {t`Annie Hollister is a JD candidate at Harvard Law School. She holds a BA (Hons) in Philosophy, Politics, and Economics and an MSc in Sociology from the University of Oxford. She grew up in New York City and is delighted to return to the East Coast after ten years in Oxford, London, and San Francisco.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderHealthAndMedicine: () => React.ReactNode = () => (
        <div className="domain-science">
            <div className="subject-title">
                <h1>{t`Health and Medicine`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/c-yue.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Carole Yue`}</h2>
                        <h4>{t`University of California, Los Angeles`}</h4>
                        <p>
                            {t`Dr. Carole Yue is an Assistant Professor of Psychology at Covenant College in Lookout Mountain, GA.  She received her Ph.D. in Psychology from the University of California, Los Angeles.  Her teaching and research interests include multimedia learning, metacognition, and the educational applications of cognitive psychology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/j-rana.jpg",
                            )}
                            style={{marginTop: "-20px"}}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jasmine Rana`}
                        </h2>
                        <h4>{t`Harvard Medical School`}</h4>
                        <p>
                            {t`Jasmine Rana is a MD Candidate at Harvard Medical School, Boston. She received her BA in Chemistry from Wellesley College. She has a special interest in medical education.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/j-walsh.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jeffrey Walsh`}
                        </h2>
                        <h4>
                            {t`The George Washington University School of Medicine`}
                        </h4>
                        <p>
                            {t`Dr. Jeffrey P. Walsh earned his M.D. from The George Washington University School of Medicine and Health Sciences in 2014.  He is currently completing his psychiatry residency at Kaiser Permanente in Southern California.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/m-jensen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Matthew Barry Jensen`}
                        </h2>
                        <h4>{t`University of Wisconsin`}</h4>
                        <p>
                            {t`Matthew B. Jensen, MD, MS, is an Assistant Professor of Neurology at the University of Wisconsin School of Medicine and Public Health. He holds a Doctor of Medicine degree from the University of Iowa and a Master of Science degree in clinical investigation from the University of Wisconsin. He’s complete his neurology residency at the University of Iowa and his vascular neurology fellowship at the University of California, San Diego.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/pv-nieuwenhuizen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Patrick van Nieuwenhuizen`}
                        </h2>
                        <h4>
                            {t`Columbia University College of Physicians and Surgeons`}
                        </h4>
                        <p>
                            {t`Patrick studied physics at Princeton, then spent two years founding and running a non profit medical organization in Zimbabwe. He is now a medical student at Columbia University.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/r-narayan.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Raja Narayan`}
                        </h2>
                        <h4>
                            {t`University of California, Irvine School of Medicine`}
                        </h4>
                        <p>
                            {t`Raja R. Narayan earned his BS in Chemistry from UC Berkeley in 2009 and MPH in Applied Biostatistics and Epidemiology from the Yale School of Public Health in 2014. Raja is currently a medical student at the UC Irvine School of Medicine and will be applying this Fall to residency in General Surgery.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/r-sahyouni.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Ronald Sahyouni`}
                        </h2>
                        <h4>
                            {t`University of California, Irvine School of Medicine`}
                        </h4>
                        <p>
                            {t`Ronald Sahyouni is in the Medical Scientist Training Program (MD/PhD) at the University of California, Irvine School of Medicine. Ron graduated with a double major in Molecular and Cell Biology and Psychology from UC Berkeley. He has conducted Glioblastoma (brain tumor) stem cell research at the Johns Hopkins Neurosurgery Department, and is interested in treating neuro-degenerative disorders with stem cell based therapies.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/r-firestone.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Ross Firestone`}
                        </h2>
                        <h4>{t`Albert Einstein College of Medicine`}</h4>
                        <p>
                            {t`Ross Firestone is an MD/PhD student at the Albert Einstein College of Medicine. His thesis research is focused on enzymology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/r-patton.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Ryan Scott Patton`}
                        </h2>
                        <h4>{t`University of Arkansas`}</h4>
                        <p>
                            {t`Ryan Patton is a medical student at Emory University School of Medicine. Before medical school, he graduated from the University of Arkansas with a BS in Nursing and spent several years working as an RN in a medical/surgical intensive care unit. He also taught critical care clinical rotations for the U of A's nursing program. He is passionate about healthcare and education, and is thrilled to blend the two at Khan Academy.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/s-desai.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Shreena Desai`}
                        </h2>
                        <h4>{t`Georgetown University`}</h4>
                        <p>
                            {t`Shreena J. Desai earned her B.S. in Biomedical Engineering from University of Connecticut in 2013 and her M.S. in Physiology Complementary and Alternative Medicine from Georgetown University in 2014. Shreena is also a research intern at the National Cancer Institute and National Institutes of Health, Division of Cancer Treatment and Diagnosis.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/s-brown.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Sydney Brown`}
                        </h2>
                        <h4>{t`Pomona College`}</h4>
                        <p>
                            {t`Sydney Brown spent time studying neuroscience at University College London in England and later received a BA in Neuroscience from Pomona College. Currently, she is studying to become a physician's assistant.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/t-kovach.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Tracy Kim Kovach`}
                        </h2>
                        <h4>{t`University of Virginia School of Medicine`}</h4>
                        <p>
                            {t`Tracy Kovach is a fourth year medical student at UVA and is pursuing a residency in Orthopedic Surgery.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl("/images/headshots/jay.jpg")}
                            style={{marginTop: "-15px"}}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jay Skipper`}</h2>
                        <h4>{t`Khan Academy`}</h4>
                        <p>
                            {t`Dr. Jay Skipper is Contributing Editor for Chemistry. He received his M.D. from the University of South Florida in 2006. Currently he is a teacher who enjoys spending time with his wife and creating portrait paintings. Jay used to spend his spare time tutoring and is thrilled that he is now able to help other students through Khan Academy.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/joshua-cohen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Joshua Cohen`}
                        </h2>
                        <h4>{t`University of Miami`}</h4>
                        <p>
                            {t`Joshua Cohen is a medical student at the University of Miami Miller School of Medicine. He received his Bachelor of Science degree from The University of Michigan and a Master of Science in physiology and biophysics from Georgetown University. His research and clinical interests lie in the field of invasive cardiology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/amy-fan.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Amy Fan`}</h2>
                        <h4>{t`University of Virginia`}</h4>
                        <p>
                            {t`Amy W. Fan is a pediatrician in her final year of residency. She graduated from the University of California, San Diego with a Bachelor's degree in Sociocultural Anthropology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/aj-grieco.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`A. J. Grieco`}
                        </h2>
                        <h4>{t`Albert Einstein College of Medicine`}</h4>
                        <p>
                            {t`A.J. is currently working on her PhD at Albert Einstein College of Medicine and holds a Masters in Biomedical Science.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/ian-mannarino.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Ian Mannarino`}
                        </h2>
                        <h4>{t`University of California, Irvine`}</h4>
                        <p>
                            {t`Ian Mannarino is a dual degree MD/MBA student at the University of California, Irvine, currently set to graduate in June 2015. After graduation, he will continue his medical training in Anesthesiology and Perioperative Care. Ian holds a special interest in both health care education and policy implementation.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/lisa-miklush.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Lisa Miklush`}
                        </h2>
                        <h4>{t`Gonzaga University`}</h4>
                        <p>
                            {t`Dr. Lisa Miklush received her PhD from the University of San Diego and is currently an assistant professor at Gonzaga University.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/nclex-winners/nauroz-syed.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Nauroz Syed`}</h2>
                        <h4>{t`Eastern Virginia Medical School`}</h4>
                        <p>
                            {t`Nauroz Syed is a Doctor of Medicine candidate at Eastern Virginia Medical School. She received her B.S. in Neuroscience from Johns Hopkins University, and her Masters of Health Science in Molecular Microbiology and Immunology from Johns Hopkins University, Bloomberg School of Public Health. She plans to pursue further training in Internal Medicine.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`BY`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Bianca Yoo`}</h2>
                        <h4>{t`University of Vermont College of Medicine`}</h4>
                        <p>
                            {t`Dr. Bianca Yoo is an internal medicine resident at the University of North Carolina, Chapel Hill, hoping to pursue a fellowship in cardiology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/jeff-otjen.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jeff Otjen`}</h2>
                        <h4>{t`Seattle Children’s Hospital`}</h4>
                        <p>
                            {t`Dr. Jeffrey Otjen is a Pediatric Radiologist at Seattle Children's Hospital and an Assistant Professor of Radiology with the University of Washington.  He received his M.D. from Baylor College of Medicine, and is double board certified in General Pediatrics and General Radiology, along with completing a fellowship in Pediatric Radiology. He teaches medical students, residents, and fellows at Seattle Children's and the University of Washington.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/vishal-punwani.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Vishal Punwani`}
                        </h2>
                        <h4>{t`St. Vincent’s Hospital Melbourne`}</h4>
                        <p>
                            {t`Vishal Punwani is an MD candidate at Melbourne Medical School, with a background in biology and nutrition. He has held lab teaching positions in biology and human anatomy at the University of Victoria, the University of British Columbia, and the University of Melbourne. Vish is passionate about medicine and physiology, but like any good Canadian, he holds ice hockey and boundless politeness above all else.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/jimmy-howick.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jimmy Howick`}
                        </h2>
                        <h4>{t`Jacksonville University`}</h4>
                        <p>
                            {t`Jimmy Howick attended Jacksonville University for undergraduate studies on a baseball scholarship but left early when chosen in the 2011 MLB Draft to play professional baseball for the Houston Astros organization. After the conclusion of his baseball career, he returned to JU and graduated from the Davis College of Business. He is currently completing the Post Baccalaureate Pre-Medical Program at Georgetown University and will apply to medical school in the coming year.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/matthew-mcpheeters.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Matthew McPheeters`}
                        </h2>
                        <h4>{t`University of Minnesota Medical School`}</h4>
                        <p>
                            {t`Matthew is a MD/MBA student at the University of Minnesota Medical School and Carlson School of Management. He is currently working the MBA portion of his studies with a focus on the medical industry. After graduation, he is planning entering the field of neurosurgery.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/brooke-miller.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Brooke Miller`}
                        </h2>
                        <h4>{t`University of Texas at Austin`}</h4>
                        <p>
                            {t`Brooke is a doctoral candidate in Developmental Psychology at the University of Texas at Austin. Her research focuses on how children develop concepts of authenticity and the role that authenticity might play in education.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`DSP`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`David Santo Pietro`}
                        </h2>
                        <h4>{t`University of California, Davis`}</h4>
                        <p>
                            {t`David is a Content Creator for Physics. He received his Masters degree in Physics at the University of California at Davis in 2006. David is currently teaching high school physics at The Meadows School in Las Vegas and investigating the effectiveness of various pedagogical approaches to teaching physics. He has published research on carbon nanotubes and is currently researching how the limitations of language affect the statements made by scientific theory.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/arshya-vahabzadeh.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Arshya Vahabzadeh`}
                        </h2>
                        <h4>{t`Harvard Medical School`}</h4>
                        <p>
                            {t`Arshya is a resident physician in child and adolescent psychiatry at the Massachusetts General Hospital and Harvard Medical School. He received his medical degree from the University of Birmingham, and his MRCGP from the Royal College of General Practitioners. He is a federal autism grant awardee, and is very interested in the neuroimmune mechanisms of autism spectrum disorders. He has received prominent leadership awards from the American Medical Association and the American Psychiatric Association.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/efrat-bruck.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Efrat Bruck`}</h2>
                        <h4>{t`Columbia University Medical Center`}</h4>
                        <p>
                            {t`Efrat currently works in Columbia University Medical Center conducting research in nephrology and clinical genetics. She has co-authored papers describing the potential use of a renal protein, NGAL, to help patients with hemochromatosis. Formerly, she taught biology, Hebrew, and music in a high school in New York City. She graduated from Touro College with a major in Biology and is now applying to medical school.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`DB`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`David Bridge`}
                        </h2>
                        <h4>{t`College of the Redwoods`}</h4>
                        <p>
                            {t`David studies biological psychology and is also a jazz musician.  His research involves attention, multi-sensory integration, and the impact that disorders in perception and sensation can have on behavior, social cognition, and decision-making. `}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`CS`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Chris Su`}</h2>
                        <h4>{t`Massachusetts Institute of Technology`}</h4>
                        <p>
                            {t`Chris graduated from Massachusetts Institute of Technology in 2011 with degrees in Biology and History. He is currently a 4th year medical student at the Icahn School of Medicine at Mount Sinai in New York City. He hopes to continue medical training in Internal Medicine following graduation.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/john-luckoski.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`John Luckoski`}
                        </h2>
                        <h4>{t`University of Toledo College of Medicine`}</h4>
                        <p>
                            {t`John is a medical student in the Class of 2017 at the University of Toledo College of Medicine. He earned his bachelors degree in Creative Writing and Philosophy at Miami University, and works as a tutor at the University of Toledo College of Medicine.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`AD`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Aleksandra Degtyar`}
                        </h2>
                        <h4>{t`University of California, Los Angeles`}</h4>
                        <p>
                            {t`Aleksandra is a medical school student at the David Geffen School of Medicine at UCLA. She received her BA in Molecular and Cell Biology from UC Berkeley in 2013.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`SN`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Sruti Nadimpalli`}
                        </h2>
                        <h4>{t`Columbia Medical Center`}</h4>
                        <p>
                            {t`Sruti Nadimpalli recently completed a Pediatric Infectious Disease fellowship at Columbia Medical Center, where she was the recipient of the Thrasher Pediatric Research Foundation Early Career Award grant. She has a specific interest in the care of immunodeficient and immunocompromised children.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`HD`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Humberto Dutra`}
                        </h2>
                        <h4>{t`Life University`}</h4>
                        <p>
                            {t`Humberto is an Associate Professor at Life University in Marietta, GA. He graduated from Campinas State University in Brazil and received his PhD from University of Missouri in St Louis. He is been teaching anatomy and physiology over the last 5 years and has his own youtube channel to teach biology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`EZS`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Edward Zed Sanchez`}
                        </h2>
                        <h4>{t`University of Central Florida`}</h4>
                        <p>
                            {t`Edward recently received his M.D. from the University of Central Florida in Orlando, Florida. Currently, he is completing his internship year in Internal Medicine at the Orlando Regional Medical Center and will be completing his residency in Diagnostic Radiology at Massachusetts General Hospital in Boston, Massachusetts.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`CL`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Clement Lin`}</h2>
                        <h4>{t`DePaul University`}</h4>
                        <p>
                            {t`Clement is a MS student in Computer Science at DePaul University. He graduated from Chang Gung Medical College in Taiwan, specializing in health, medicine, and social sciences related information management.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/theo-roth.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Theodore Roth`}
                        </h2>
                        <h4>{t`University of California, San Francisco`}</h4>
                        <p>
                            {t`Theodore is an MD/PhD student at the University of California, San Francisco. From Birmingham, Alabama, he is a graduate of Stanford University with degrees in biology and biomedical informatics.  At UCSF he works on medical and immunology research.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`GT`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Garrick Trapp`}
                        </h2>
                        <h4>{t`Columbia University Medical Center`}</h4>
                        <p>
                            {t`Garrick currently researches pancreatic and gastric cancer for the Pancreas Center at Columbia University Medical Center. Before working for Columbia, Garrick worked as a curriculum designer and content creator for tutoring companies in New York City and the San Francisco Bay Area. Garrick holds degrees in Astrophysics, Comparative Literature, and Music from the University of California, Berkeley where he also taught for the Physics and Astronomy departments.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`WT`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`William Tsai`}
                        </h2>
                        <h4>{t`NYU School of Medicine`}</h4>
                        <p>
                            {t`William has a B.S. in Biochemistry from CSULA and has recently received his M.A. in Teaching with a specialization in Secondary Science from Relay GSE. He taught high school chemistry and physics in Bronx, NY as a Teach for America Corps member from 2012-2014. He is currently a medical student at NYU School of Medicine.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`KM`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Kelly MacKenzie`}
                        </h2>
                        <h4>{t`American University`}</h4>
                        <p>
                            {t`Kelly earned her MA in Psychology from American University in Washington DC in 2012.  For the next two years she served as a co-investigator of the Female Athlete Body Project, a NIMH funded clinical trial that focused on the prevention of eating disorders in college athletes. She hopes to eventually pursue a PhD in Health Psychology.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`AZ`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Allen Zheng`}</h2>
                        <h4>{t`University of California, Berkeley`}</h4>
                        <p>
                            {t`For the past two years, I have mentored Los Angeles high school students, from lower income neighbourhoods, as a college access advisor. The opportunity to level the playing field for these students, especially those interested in pursuing medical education, is what motivates me.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`LP`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Lucas Philipp`}
                        </h2>
                        <h4>{t`Emory University School of Medicine`}</h4>
                        <p>
                            {t`Lucas is an MD candidate at Emory University School of Medicine in Atlanta, Georgia. Previously, he attended the University of Kansas, where he graduated with Distinction with a BA in Human Biology and a Minor in Music. Lucas has worked for several years as a tutor at the University of Kansas, and has longstanding interests in education and the sciences.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`RH`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Rabee Haq`}</h2>
                        <h4>{t`University of Maryland, College Park`}</h4>
                        <p>
                            {t`Rabee recently received his BA in Positive Psychology, Philosophy, and Happiness from the University of Maryland, College Park. He is currently working as a clinical intern, a teaching assistant, and is the primary investigator of psychological research on campus.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`JC`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jeff Collins`}
                        </h2>
                        <h4>{t`Westminster College`}</h4>
                        <p>
                            {t`Jeff is a pre-medical student from Salt Lake City, Utah. He received his B.S. with majors in Biology and Environmental Science from Westminster College. His research has focused on mercury bioaccumulation and microbial diversity in the Great Salt Lake. He now serves as a volunteer coordinator for a free clinic through Americorps VISTA.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`BK`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Bradley Kolb`}
                        </h2>
                        <h4>{t`University of Michigan`}</h4>
                        <p>
                            {t`Bradley is a researcher at the University of Michigan Department of Neurosurgery, where he studies interactions between cancer and the immune system. Before coming to Michigan, he studied philosophy and mathematics at the Ohio State University. He plans to start medical school in the fall of 2015.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`JB`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jason Batten`}
                        </h2>
                        <h4>{t`Stanford University School of Medicine`}</h4>
                        <p>
                            {t`Jason Batten is currently a medical student at the Stanford University School of Medicine. Before applying to medical school, he taught chemistry and physics in South Central Los Angeles, initially as a 2008 Teach For America Corps Member. He served in several capacities as a teacher leader on the school and district level. In 2012, Jason earned a master's degree in bioethics and began serving in the bioethics department of a community hospital. He continues to be actively involved in research in both science education and clinical ethics.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/mcat-winners/jordan-weil.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jordan Weil`}</h2>
                        <h4>{t`University of Minnesota, Twin Cities`}</h4>
                        <p>
                            {t`Jordan is a class of 2017 medical student at the University of Minnesota’s Twin Cities campus.  He earned a bachelor’s degree with majors in mathematics and physics from the University of Chicago, and completed post-baccalaureate pre-medical work at Loyola University Chicago.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        {doNotTranslate`SY`}
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Sze Yan`}</h2>
                        <h4>{t`University of Chicago`}</h4>
                        <p>
                            {t`Sze received his BA from the University of Chicago and currently works as an educational consultant in the New York area.  Over the past decade, he has worked for various organizations to develop content and to prepare students for the MCAT with his recent focus on working with students from underrepresented and non-traditional backgrounds.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/william_gilpin.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`William Gilpin`}
                        </h2>
                        <h4>{t`Stanford University`}</h4>
                        <p>
                            {t`William Gilpin earned his A.B. in physics from Princeton University, where he conducted research in areas ranging from quantum photonics to biomechanics. He is currently working on a PhD in applied physics at Stanford, where he is developing theoretical models of the origin of life.`}
                        </p>
                    </div>
                </div>
                <div className="team-card">
                    <div className="card-photo card-initials">
                        <img
                            alt=""
                            src={staticUrl(
                                "/images/headshots/content-specialists/emma_giles.jpg",
                            )}
                        />
                    </div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Emma Giles`}</h2>
                        <h4>{t`Boston Children's Hospital`}</h4>
                        <p>
                            {t`Emma is a pediatric researcher at the Boston Children's Hospital. She holds a MSc in Neuroscience from the Florey Neuroscience Institute (Melbourne), and completed her BSc as a combined major in biology and psychology at the University of Victoria (Canada). Emma's favorite thing to do is exercise &ndash; she runs several times a week and loves hiking and hockey.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    renderArtAndHistory: () => React.ReactNode = () => (
        <div className="domain-humanities">
            <div className="subject-title">
                <h1>{t`Art History and History`}</h1>
            </div>

            <div className="portrait-container">
                <div className="team-card">
                    <div className="card-photo card-initials">{t`AC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Amy Calvert`}
                        </h2>
                        <p>
                            {t`Dr. Amy Calvert is the Contributing Editor for Ancient Egyptian art. Amy holds a Ph.D. from the Institute of Fine Arts at New York University and has been involved in several excavations in Italy, Egypt, and the U.S. She acted as registrar in the field for the Osiris Temple Project with the Yale-University of Pennsylvania-New York University Expedition to Abydos and has worked at The British Museum and the Museum of Fine Arts, Boston.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Esperança Camara`}
                        </h2>
                        <p>
                            {t`Dr. Esperança Camara is Contributing Editor for Renaissance and Baroque Art. She received her BA from Reed College and her PhD from Johns Hopkins University with concentrations in Italian Renaissance and Baroque art and nineteenth-century French art. Her research focuses on Italian devotional art of the post-Tridentine period. In 2006 she received the Excellence in Teaching and Campus Leadership Award at the University of Saint Francis in Fort Wayne, Indiana where she is currently Associate Professor of Art History and Director of the MA in Studio Art Program.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Sally Hickson`}
                        </h2>
                        <p>
                            {t`Dr. Sally Hickson is Contributing Editor for Renaissance art in Northern Italy. She is Associate Professor of Renaissance Art History at the University of Guelph. Sally received the H.P. Krauss Fellowship in early books and manuscripts at the Beinecke Library at Yale University (2009), and the Natalie Zemon Davis Award from the Journal Renaissance and Reformation (2010). She is the author of Women, Art and Architectural Patronage in Renaissance Mantua: Matrons, Mystics and Monasteries (2012), and co-editor of Inganno—The Art of Deception (2012).`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RJE`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Rebecca Jeffrey Easby`}
                        </h2>
                        <p>
                            {t`Dr. Rebecca Jeffrey Easby is the Contributing Editor for 19th Century Art and an Associate Professor of Art History and Chair of the Fine Arts Program at Trinity Washington University in Washington, D.C. Her research can be found in publications such as The Burlington Magazine and History and Community: Essays in Victorian Medievalism (Garland Press). She received her Ph.D. from the Courtauld Institute of Art, University of London.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Steven Fine`}
                        </h2>
                        <p>
                            {t`Dr. Steven Fine is contributing editor for Jewish Art. He received his doctorate in Jewish History from the Hebrew University of Jerusalem, and his MA in Art History from USC. Fine’s Art and Judaism in the Greco-Roman World: Toward a New Jewish Archaeology (2005; rev. ed. 2010) received the Association for Jewish Studies' Jordan Schnitzer Book Award in 2009. He is Professor of Jewish history at Yeshiva University and director of the Arch of Titus Digital Restoration Project.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LGKE`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Lauren G. Kilroy-Ewbank`}
                        </h2>
                        <p>
                            {t`Dr. Lauren G. Kilroy-Ewbank is the Contributing Editor for Latin American Colonial art. She received her Ph.D. in Art History from the University of California Los Angeles. In 2013, she received a Mrs. Giles Whiting Foundation Fellowship for Excellence in Teaching at Brooklyn College, CUNY, where she is currently an Assistant Professor of Art History.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EML`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Elizabeth Macaulay-Lewis`}
                        </h2>
                        <p>
                            {t`Dr. Elizabeth Macaulay-Lewis is Contributing Editor for the Arts of the Islamic World. She is an archaeologist and architectural historian. She is currently Visiting Assistant Professor at the Graduate Center at CUNY and serves on the governing board of the Archaeological Institute of America. She has a DPhil in Classical Archaeology from Oxford University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Joanna Milk Mac Farland`}
                        </h2>
                        <p>
                            {t`Dr. Joanna Milk Mac Farland is Contributing Editor for Fourteenth- and Fifteenth-Century Tuscan Art. She recently received her Ph.D. in the History of Art from the University of London’s Courtauld Institute of Art, where she attended as a Thomas Lee scholar. Currently, she is working on a book project investigating depictions of visionary experience in early Renaissance Italy.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`NR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Nancy Ross`}
                        </h2>
                        <p>
                            {t`Dr. Nancy Ross is Contributing Editor for Medieval Art. She received her Ph.D. in the History of Art from Cambridge University in 2007. She specializes in medieval illuminated manuscripts and teaches art history at Dixie State College of Utah.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AY`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Allison Young`}
                        </h2>
                        <p>
                            {t`Allison Young is Contributing Editor for Global Modern and Contemporary Art. She is a doctoral candidate in Art History at the Institute of Fine Arts, NYU. She has held positions at the Museum of Fine Arts, Boston, the Rose Art Museum at Brandeis University and the Metropolitan Museum of Art. Allison is currently a graduate fellow in NYU’s Global Research Center in London.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BJZ`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Bryan J. Zygmont`}
                        </h2>
                        <p>
                            {t`Dr. Bryan J. Zygmont is Contributing Editor for American Art. He earned his Ph.D. from the Department of Art History and Archaeology at the University of Maryland in 2006. He is currently Assistant Professor of Art History at Clarke University in Dubuque, Iowa. Zygmont is the author of Portraiture and Politics in New York City, 1790-1825: Gilbert Stuart, John Vanderlyn, John Trumbull, and John Welsey Jarvis, a book he partially wrote while a Visiting Scholar at the National Portrait Gallery. Zygmont was a Fulbright Scholar in 2013.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KBA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Kris Belden-Adams`}
                        </h2>
                        <p>
                            {t`Dr. Kris Belden-Adams is an Assistant Professor of Art History at the University of Mississippi. Her work has appeared in Afterimage, Cabinet, and in the Metropolitan Museum of Art’s 2012 book Faking It: Manipulated Photography before Photoshop.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`WA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. William Allen`}
                        </h2>
                        <p>
                            {t`Dr. William Allen teaches art history at Arkansas State University. William received his doctorate from Johns Hopkins in Byzantine art and architecture. He has traveled widely and lived for periods in Turkey and Afghanistan`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Jessica L. Ambler`}
                        </h2>
                        <p>
                            {t`Dr. Jessica L. Ambler holds a Ph.D. from the University of California, Santa Barbara with a specialization is Roman architecture. She was a Post-Doctoral Research Fellow at UCSB and a Curatorial Assistant at the Santa Barbara Museum of Art. She now teaches Humanities online for Southern New Hampshire University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Colette Apelian`}
                        </h2>
                        <p>
                            {t`Dr. Colette Apelian has a doctorate in art history from the University of California, Los Angeles where she specialized in Islamic Art and Architectural History. Dr. Apelian lives and researches in Morocco and is currently writing a manuscript on the histories of electricity and automobiles in French colonial Fez, among other projects that address the visual cultures of North Africa. Dr. Apelian teaches online for Berkeley City College.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RDA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Roger D. Arnold`}
                        </h2>
                        <p>
                            {t`Roger D. Arnold is currently Curatorial Assistant for the Arts of Africa, Pacific Islands, Asia, and the Islamic World at the Brooklyn Museum. He has held professional appointments in museums, libraries, and archives throughout the New York City area. His research interests include West and Central African textiles, and the display and interpretation of African art in American museums. He studied Art History and Africana studies at Hobart &amp; William Smith Colleges and City College of the City University of New York.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DAH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Darius Arya He`}
                        </h2>
                        <p>
                            {t`Dr. Darius Arya He received his Ph.D. in Classical Archaeology from the University of Texas in Austin in 2002. He has been a Fulbright Fellow and a Fellow of the American Academy in Rome. Darius co-founded the American Institute for Roman Culture and has directed numerous excavations including digs in the Roman Forum and Ostia Antica. has appeared the History, National Geographic, and Discovery Channels.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JAB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Jeffrey A. Becker`}
                        </h2>
                        <p>
                            {t`Dr. Jeffrey A. Becker has focused his research on Italo-Roman architecture and urbanism, but is interested in urbanism across the Mediterranean basin, as a well as in building techniques, city planning, Roman villas, and archaeological theory. Becker was trained in Classics at the University of North Carolina at Chapel Hill (M.A., Ph.D.) and has extensive experience as a classroom instructor and as an excavator, having worked for a number of years in and around Rome.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JBdD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Javier Berzal de Dios`}
                        </h2>
                        <p>
                            {t`Dr. Javier Berzal de Dios received his Ph.D. from Ohio State University. He is an Assistant Professor of Early Modern Art and Critical Theory at Western Washington University. His research and writing addresses the intersections of art, architecture, and theory, with a focus on space and spatiality.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Christine Bolli`}
                        </h2>
                        <p>
                            {t`Christine Bolli is a Ph.D. candidate at the University of California, Santa Barbara focusing on Romanesque architecture in Provence and Cistercian architecture. Christine works as an instructor for Brooks Institute in Santa Barbara and Ventura as well as for CSU Channel Islands. She writes for Art Fix Daily.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Doris Bravo`}</h2>
                        <p>
                            {t`Doris Bravo is a Ph.D. candidate in Art History at The University of Texas at Austin, specializing in twentieth-century Latin American art. She is currently completing her dissertation research in Chile with support from the Institute of International Education Graduate Fellowship for International Study.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Alexander Brey`}
                        </h2>
                        <p>
                            {t`Alexander Brey is a Ph.D. candidate in the History of Art at Bryn Mawr College, where he also received his M.A. His thesis focused on early medieval triconch halls and the early Islamic palace known as Mushatta, and his dissertation is about images of hunting in architectural decoration produced within the Umayyad empire.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KTB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Katherine T. Brown`}
                        </h2>
                        <p>
                            {t`Dr. Katherine T. Brown is Assistant Professor of Art History and Director of Museum Studies at Walsh University in North Canton, Ohio. She received her M.A. and Ph.D. from Indiana University-Bloomington. Research areas of interest include images of the Madonna della Misericordia in Medieval and Renaissance art, self-portraiture in Venice during the Renaissance, and the oeuvre of Luca Signorelli.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CB`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Catherine Burdick`}
                        </h2>
                        <p>
                            {t`Dr. Catherine Burdick holds a Ph.D. in Art History from the University of Illinois at Chicago, specializing broadly in pre-Columbian Mesoamerica, and specifically in relationships between portraiture and hieroglyphs in Classic Maya sculpture. She has taught art history at several institutions, including Milwaukee Institute of Art and Design and UIC.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Emily Casden`}
                        </h2>
                        <p>
                            {t`Emily Casden received her M.A. in art history from Hunter College in 2011. She specializes in twentieth-century modernism, with a strong interest in German Expressionism, Futurism, Interwar and Postwar art, and art theory and aesthetics.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Matt Collins`}
                        </h2>
                        <p>
                            {t`Matt Collins is a Ph.D. candidate in Italian Studies at Harvard University, where he specializes in medieval and modern cultural history. He earned his MA from New York University’s Institute of Fine Arts. His thesis was on the convergence of propagandized literature, art and architecture under the fascist regime. His dissertation will deal with particular illustrations of Dante’s Divine Comedy.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Christina Connett`}
                        </h2>
                        <p>
                            {t`Dr. Christina Connett is Curator of Exhibitions and Collections at the New Bedford Whaling Museum in New Bedford, Massachusetts. She has an MA from the University of Auckland New Zealand, and a Ph.D. candidate from the University of Valencia in Spain. Connett has taught Art History and the History of Cartography at the Rhode Island School of Design and University of Massachusetts, Dartmouth.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`PC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Pippa Couch`}</h2>
                        <p>
                            {t`Pippa Couch holds a Masters in History of Art from the Courtauld Institute of Art, London and specializes in the art from Antiquity to Byzantium. She is currently working as a gallery educator at the Courtauld Institute Galleries and the Dulwich Picture Gallery in London.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Joseph Dauben`}
                        </h2>
                        <p>
                            {t`Dr. Joseph Dauben is Distinguished Professor of History at Herbert H. Lehman College and the Graduate School and University Center of the City University of New York. He has published widely on many subjects including the History of Science, the History of Mathematics, the Scientific Revolution, Sociology of Science, and Intellectual History. He received his Ph.D. at Harvard University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Radha Dalal`}
                        </h2>
                        <p>
                            {t`Dr. Radha Dalal is Assistant Professor of islamic Art and Architecture at Virginia Commonwealth University in Doha, Qatar. She researches visual cultures of mobility with a particular emphasis on architecture and the urban environment of the Ottoman Empire in the 19th and early 20th centuries and the empire’s socio-political interactions with other European and Asian polities.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Linda Downs`}</h2>
                        <p>
                            {t`Linda Downs is Executive Director and CEO of College Art Association. Previously she was Director of the Figge Art Museum; Director of Education at the National Gallery of Art; and Curator of Education at the Detroit Institute of Arts. She has an M.A. in the history of art from the University of Michigan, post graduate study in history at American University and a Ph.B. from Monteith College at Wayne State University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. David Drogin`}
                        </h2>
                        <p>
                            {t`Dr. David Drogin has been a professor in the History of Art Department at SUNY's Fashion Institute of Technology since 2004 and has previously taught at Wesleyan University, Harvard and Yale. A specialist in Italian Renaissance art, he received his M.A. and Ph.D. from Harvard University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DD`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Davor Džalto`}
                        </h2>
                        <p>
                            {t`Dr. Davor Džalto is associate professor of art history, art theory and religious studies at the American University of Rome. He earned his Ph.D. from the University of Freiburg, on the topic “The Role of the Artist in Self-Referent Art." He has published five books and over 30 scholarly articles and essays.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`NEM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Nausikaä El-Mecky`}
                        </h2>
                        <p>
                            {t`Dr. Nausikaä El-Mecky is a fellow of the interdisciplinary research group Bildakt und Verkörperung at the Humboldt University in Berlin and a lecturer at the Freie Universität in Berlin and Utrecht University in the Netherlands. She received her Ph.D. in History of Art from the University of Cambridge in 2013 for her thesis "Dangerous Art: Towards a Theory of Organised Legal Attacks on European Art."`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Allen Farber`}
                        </h2>
                        <p>
                            {t`Dr. Allen Farber has taught at the State University of New York College at Oneonta since 1981. He has been responsible for teaching a range of courses including upper level courses in Ancient, Medieval, and Renaissance art. He received his Ph.D. from Cornell University in 1980.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Abram Fox`}
                        </h2>
                        <p>
                            {t`Dr. Abram Fox holds a doctorate in art history and archaeology from the University of Maryland, where he specialized in eighteenth century British and American painting. In addition to his dissertation research on the transatlantic artistic and educational exchange centered on the workshop of Benjamin West, Abram has published work on twentieth-century Czech postcards, and comic books in art history.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Bernard Frischer`}
                        </h2>
                        <p>
                            {t`Dr. Bernard Frischer authored, or co-authored, six books and many articles on virtual heritage and on the Classical world and its survival. He is Professor of Informatics at Indiana University, Bloomington. Previously, he was Professor of Art History and Classics at the University of Virginia where he was Director of the Virtual World Heritage Laboratory. Dr. Frischer’s many projects include "Rome Reborn," the virtual recreation of the city of ancient Rome within the Aurelian Walls. He received his Ph.D. in Classics summa cum laude from the University of Heidelberg.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Julia Fischer`}
                        </h2>
                        <p>
                            {t`Dr. Julia Fischer is a Lecturer of Art History at Georgia Southern University. She has also taught at Columbus College of Art and Design, Denison University, and The Ohio State University. Her dissertation is titled “For Your Eyes Only: Private Propaganda in Roman Imperial Cameos." Her research explores the iconography of Roman imperial cameos.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Meg Floryan`}</h2>
                        <p>
                            {t`Meg Floryan earned her Masters in American Fine &amp; Decorative Art from Sotheby's Institute of Art in New York.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jennifer Freeman`}
                        </h2>
                        <p>
                            {t`Jennifer Freeman is interested in the relationship between medieval art and theology. In 2009, she received her Master of Art in Religion from Yale Divinity School and is currently a doctoral candidate in religion at Vanderbilt University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SGL`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Shana Gallagher-Lindsay`}
                        </h2>
                        <p>
                            {t`Dr. Shana Gallagher-Lindsay has taught the history of Western art at the Fashion Institute of Technology, S.U.N.Y., since 1994. Her areas of specialization are modern and contemporary art, and photography. She completed her Ph.D. at the City University of New York Graduate Center in 2003, writing her dissertation on the installation artist, Marcel Broodthaers.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SG`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Senta German`}
                        </h2>
                        <p>
                            {t`Dr. Senta German, now at the Ashmolean Museum of Art and Archaeology, University of Oxford, earned her Ph.D. at Columbia University in Aegean, Greek and Ancient Near Eastern archaeology and art. She explores the intersection of art and ancient Greek society with specific attention to performance, gender and the impacts of the illicit antiquities trade and forgery. She has taught at Columbia University, New York University, Rutgers University and was Associate Professor of Classics and Art History at Montclair State University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BSGN`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Beth S. Gersh-Nesic`}
                        </h2>
                        <p>
                            {t`Dr. Beth S. Gersh-Nesic earned her Ph.D. in art history from the City University of New York Graduate Center and currently teaches art history at Purchase College. Her specialty is Modern Art with an emphasis on Picasso and Cubism.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`PG`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Parme Giuntini`}
                        </h2>
                        <p>
                            {t`Dr. Parme Giuntini received her Ph.D. from UCLA where she focused on 18th century British portraiture and the development of a modern domestic ideal. She directs the Art History program at Otis College of Art and Design where her scholarly interests in portraiture and gender have broadened into fashion and identity.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AKH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Amy K. Hamlin`}
                        </h2>
                        <p>
                            {t`Dr. Amy K. Hamlin focuses on early twentieth-century German art, particularly the work of Max Beckmann. Hamlin earned a Ph.D. from the Institute of Fine Arts at NYU and is currently an Assistant Professor of Art History at St. Catherine University, where she teaches across the art history curriculum.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KMH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Kristen M. Harkness`}
                        </h2>
                        <p>
                            {t`Dr. Kristen M. Harkness specializes in Russian art of the late-nineteenth century and its relationship to the varied arts and crafts movements then developing across Europe. Dr. Harkness is currently a Lecturer at West Virginia University and an Instructor at University of Pittsburgh where she earned her Ph.D.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Sophie Harland`}
                        </h2>
                        <p>
                            {t`Sophie Harland completed her Masters at the Courtauld Institute of Art, writing her dissertation on the reproduction of ancient sculpture in eighteenth-century Britain. During her studies she wrote for and edited a number of gallery publications as well as delivering public talks in the Courtauld Gallery.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Jessica Hammerman`}
                        </h2>
                        <p>
                            {t`Dr. Jessica Hammerman is Assistant Professor of World and European History at Central Oregon Community College in Bend, Oregon. Her research focuses on interactions among Jews, Muslims, and Christians in decolonizing Algeria in the 1950s and 1960s.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Shaina Hammerman`}
                        </h2>
                        <p>
                            {t`Dr. Shaina Hammerman received her Ph.D. in Jewish History and Culture from the Graduate Theological Union (GTU) in Berkeley, California. She specializes in modern Jewish culture with an emphasis on French and American film and literature. She has taught Jewish history and religion at the GTU, UC Davis, and Mills College.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LAH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Leila Anne Harris`}
                        </h2>
                        <p>
                            {t`Leila Anne Harris is a doctoral student in art history at the Graduate Center, City University of New York, where she specializes in the history of photography. Her research and writing focus on nineteenth century photography, gender, and domesticity.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SLH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Shawnya L. Harris`}
                        </h2>
                        <p>
                            {t`Dr. Shawnya L. Harris is an Assistant Professor of Art History at Elizabeth City State University. She earned her Ph.D. degree in art history from the University of North Carolina at Chapel Hill. Her research interests include modern and contemporary arts of the African diaspora and issues related to art collecting and patronage.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Benjamin Harvey`}
                        </h2>
                        <p>
                            {t`Dr. Benjamin Harvey is an associate Professor of art history at Mississippi State University, Ben received graduate degrees from the University of Birmingham, UK, and UNC-Chapel Hill. His research focuses on word-and-image issues, especially as they relate to 19th century France and early 20th century Britain. His work has appeared in numerous venues, including publications by Cornell University Press, Edinburgh University Press, and Palgrave MacMillan.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Margaret Herman`}
                        </h2>
                        <p>
                            {t`Dr. Margaret Herman earned a Ph.D. from the Graduate Center of the City University of New York, where she specialized in early twentieth-century architecture and urbanism. She has taught courses in art and architectural history at City College, Parsons, and Montclair State University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`HAH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Heather A. Horton`}
                        </h2>
                        <p>
                            {t`Dr. Heather A. Horton specializes in Medieval and Renaissance art and architectural history, especially the works of the writer and architect Leon Battista Alberti. Horton earned her Ph.D. from the Institute of Fine Arts. She is a frequent guest lecturer at The Cloisters Museum and has taught art history at New York University, The City University of New York, and Purchase College; currently she teaches art and design at Pratt Institute.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RK`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Roshna Kapadia`}
                        </h2>
                        <p>
                            {t`Roshna Kapadia has an MA in South Asian Studies from the University of Pennsylvania and has recently completed an MA in Art History at George Mason University. Her primary area of focus is South Asian art (Buddhist sculpture, Hindu architecture, Islamic painting from the Mughal era).`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`FK`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Farisa Khalid`}
                        </h2>
                        <p>
                            {t`Farisa Khalid holds a Masters in art history from the Institute of Fine Arts. Her primary area of interest is nineteenth and twentieth century American art and visual culture with a sub-specialty in South Asian art.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KK`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Katrina Klaasmeyer`}
                        </h2>
                        <p>
                            {t`Katrina Klaasmeyer earned her Masters in Art History from the University of Oregon, with her thesis "Capitalist Realism: The Work of Gerhard Richter, Sigmar Polke and Konrad Lueg, 1962-67." She curated an exhibition on the Japanese tradition of manga as it relates to war and romance comics of the 1940s-50s at the Jordan Schnitzer Museum of Art.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JK`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Juliana Kreinik`}
                        </h2>
                        <p>
                            {t`Dr. Juliana Kreinik has taught the History of Photography at SUNY, New Paltz, Pace University, and Pratt Institute and lectured on German art of the Weimar era. She received her Ph.D. from New York University's Institute of Fine Arts.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CL`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Chad Laird`}</h2>
                        <p>
                            {t`Chad Laird has taught in the History of Art Department at the Fashion Institute of Technology since 2005. He received his M.A. in Art History and Criticism from Stony Brook University in 2000, and now concentrates on filmmaking, music and sound art.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JL`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Julia Langley`}
                        </h2>
                        <p>
                            {t`Julia Langley received an M.A. in ancient Greek art history from the University of California, Los Angeles. She also completed the graduate program in Museum Studies at the George Washington University with a study of the war memorials on the National Mall.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AL`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Ayla Lepine`}
                        </h2>
                        <p>
                            {t`Dr. Ayla Lepine specializes in British nineteenth-century art and architectural history. Prior to obtaining her Ph.D. at The Courtauld Institute of Art in 2011, she studied art history and theology at the University of Victoria and Oxford University. Her thesis focused on intersections between the Gothic Revival, Anglicanism, Oxford, and Cambridge.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Dana Martin`}</h2>
                        <p>
                            {t`Dana Martin received her Master’s in art history from Long Beach State University in 2012. Her thesis focused on the theme of heroic death in American art. She currently teaches art history and humanities courses in the southern California.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Anne McClanan`}
                        </h2>
                        <p>
                            {t`Dr. Anne McClanan teaches at Portland State University. She published a book analyzing Byzantine empresses and edited an anthology on Iconoclasm (published as well in Chinese translation) and another anthology on the material culture of sex, procreation and marriage.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Jennifer N. McIntire`}
                        </h2>
                        <p>
                            {t`Dr. Jennifer N. McIntire teaches art history part-time at the University of Massachusetts, Dartmouth. She received her Ph.D. from Princeton University in Far Eastern Art History. Making Chinese art accessible and understandable to a wide variety of people is a primary interest.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Jp McMahon`}</h2>
                        <p>
                            {t`Jp McMahon is a Ph.D. candidate in Art History at University College Cork, Ireland. He currently teaches and is academic coordinator on the diploma in European Art History in the Adult Education department of the same university. He has published a number of essay on American art since 1945.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jeremy Miller`}
                        </h2>
                        <p>
                            {t`Jeremy Miller has taught art history at the Fashion Institute of Design and Merchandising in San Francisco since 2006. He received his MA in Art History from San Francisco State University in 2007, with an emphasis on Venetian Art.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Shadieh Mirmobiny`}
                        </h2>
                        <p>
                            {t`Shadieh Mirmobiny is an adjunct Professor of art history at Folsom Lake College; she also teaches at Sierra College and American River Colleges, where she teaches Western and non-Western art history survey courses. Her field of interest and focus of study is critical theory in art history.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BJN`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Bonnie J. Noble`}
                        </h2>
                        <p>
                            {t`Dr. Bonnie J. Noble is Contributing Editor for the Northern Renaissance. She is Associate Professor of Art History at the University of North Carolina at Charlotte. She received her Ph.D. in art history from Northwestern University, her MA in art history from the University of Pennsylvania. Her specialization is the art of the Northern Renaissance, particularly sixteenth-century German painting.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`NCP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Noelle C. Paulson`}
                        </h2>
                        <p>
                            {t`Dr. Noelle C. Paulson, a specialist in nineteenth-century European art history, received her MA and Ph.D. from Washington University in St. Louis. Since moving to Switzerland at the end of 2009, she has been an independent art historian, researcher, and freelance writer for museums in Italy, the Netherlands, Switzerland, Canada, and the U.S.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`IP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Isaac Peterson`}
                        </h2>
                        <p>
                            {t`Isaac Peterson is an artist, a writer, and a teacher. His writing is published primarily in Flash Art magazine. In his studio work, he focuses on drawing and animation, but constantly returns to oil painting.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`DP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dianne Pierce`}
                        </h2>
                        <p>
                            {t`Dianne Pierce is part-time faculty at the State University of New York at New Paltz teaching history of decorative arts, modern design, museum studies, and architecture of New York City. In addition, Dianne is part-time faculty at Parsons The New School for Design in New York, teaching the history of decorative arts and other courses.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`BP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Ben Pollitt`}</h2>
                        <p>
                            {t`Ben Pollitt studied Art History and English Literature at Edinburgh University. He teaches Art History at Fine Arts College in Hampstead and Ashbourne College in Kensington. He is an A Level examiner in the subject.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Chloe Portugeis`}
                        </h2>
                        <p>
                            {t`Dr. Chloe Portugeis received a Ph.D. from Yale University in 2014 where she specialized in Victorian art. She has presented papers at CUNY and Vanderbilt University and worked as a research assistant at the Yale Center for British Art and as an intern for Venice Guggenheim and the de Young Museum in San Francisco.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Matthew Postal`}
                        </h2>
                        <p>
                            {t`Dr. Matthew Postal is a historian of 20th-century architecture and urbanism. A graduate of Vassar College and New York University's Institute of Fine Arts, he earned his Ph.D. at the Graduate Center of City University in 1998, where his dissertation examined the relationship between Modernism, museums, and the media.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Shannon Pritchard`}
                        </h2>
                        <p>
                            {t`Dr. Shannon Pritchard is Assistant Professor of Art History at the University of Southern Indiana in Evansville, Indiana. She received her Ph.D. from the University of Georgia. Continued areas of research include broader issues of the paragone in late sixteenth-century Florence, Caravaggio and his use of prints, and Giambologna’s role within the Accademia del Disegno in Florence.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Stephanie Roberts`}
                        </h2>
                        <p>
                            {t`Stephanie Roberts received her Masters degree from the Courtauld Institute of Art, London. Her research interests include 19th century British Art, the History of Art in Wales, and Tudor and Stuart portraiture.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Lynn Robinson`}
                        </h2>
                        <p>
                            {t`Lynn Robinson holds a Masters degree in art history from the University of California, Los Angeles, where she specialized in Theory and Criticism. She also received a Museum Studies degree with an emphasis on museum education from John F. Kennedy University. She is currently an Adjunct Professor of Visual Studies at California College of the Arts.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EOR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Emmanuel Ortega Rodríguez`}
                        </h2>
                        <p>
                            {t`Emmanuel Ortega Rodríguez is a Ph.D. Doctoral Candidate in Ibero-America colonial art history from the University of New Mexico where he also earned his MA Masters in Art History of the Americas. Both, his thesis and doctoral dissertation are works that developed around the need to better understand the peculiar nature of images of violence and death created in the Latin American colonial context.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Shawn Roggenkamp`}
                        </h2>
                        <p>
                            {t`Shawn Roggenkamp received her Masters in History of Art from the Courtauld Institute of Art. She specializes in early Twentieth Century German art and culture with a focus on emigre artists and their influence, particularly on American Post-War art, and cross-disciplinary development between the visual and performing arts.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RSR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Rachel S. Ropeik`}
                        </h2>
                        <p>
                            {t`Rachel S. Ropeik is Senior Museum Educator/Teacher Services Coordinator at Brooklyn Museum and a 19th century specialist particularly interested in the intersection of art and costume histories. She received her MA in Art History from the Courtauld Institute of Art where she examined 19th century masculinity and 20th century gender theory.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Josh Rose`}</h2>
                        <p>
                            {t`Josh Rose earned an MA in Art History from the University of North Texas in 2003. In the years since, he has worked in museum art education, designing adult programming at the Nasher Sculpture Center and the Dallas Museum of Art. His areas of research interest include Surrealism and Surrealist photography.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`ER`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Elisabeth Rowney`}
                        </h2>
                        <p>
                            {t`Elisabeth Rowney is Associate Course Director of Art History at Full Sail University in Winter Park, Florida. She received her Master's Degree from the University of South Florida. Her primary focus is the concept of fallen women.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JMS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Jordana Moore Saggese`}
                        </h2>
                        <p>
                            {t`Dr. Jordana Moore Saggese is an assistant professor of Visual Studies, and affiliated faculty in the Graduate Program in Visual and Critical Studies at California College of the Arts. Trained as an art historian, her work focuses on modern and contemporary art with an emphasis on the expressions and theorizations of blackness.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`WS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Wendy Schaller`}
                        </h2>
                        <p>
                            {t`Dr. Wendy Schaller is an Associate Professor of Art History at Ashland University. She earned her BA from the University of Tennessee and both her MA and Ph.D. in art history from the Ohio State University. Her research focuses primarily on portraits of children and the subject of death, grief and consolation in the seventeenth-century Netherlands.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Karen Schifman`}
                        </h2>
                        <p>
                            {t`Karen Schifman is an Art Historian who focuses particularly on women artists and the representation of women in visual culture. She received her MA from California State University, Northridge.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Karen Shelby`}
                        </h2>
                        <p>
                            {t`Dr. Karen Shelby is an Assistant Professor of Art History at Baruch College, The City University of New York. Her research focuses on the visual culture of Flemish nationalism in the Great War. Her book, Flemish Nationalism and the Great War: The Politics of Memory, Visual Culture and Commemoration, will be published in spring 2014.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`VS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Valerie Spanswick`}
                        </h2>
                        <p>
                            {t`Valerie Spanswick earned her BA in art history from the University of Washington in Seattle, which included studying both Classic and Baroque art and architecture in Rome. She earned her MA in the history of art from the University of York with a focus on 18th and 19th century British art and architecture.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`VBS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Virginia B. Spivey`}
                        </h2>
                        <p>
                            {t`Dr. Virginia B. Spivey is an art writer specializing in late 20th and 21st century art history and theory. She holds a Ph.D. in art history from Case Western Reserve University. Now based in Washington D.C., she develops art history educational materials in addition to her scholarly work, which is currently focused on the relationship of performance to contemporary craft production.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Robert Summers`}
                        </h2>
                        <p>
                            {t`Dr. Robert Summers received his Ph.D. in Art History at UCLA. Currently he is a lecturer at Otis College of Art, where he received the Excellence in Teaching award (2010-2011), and he was a Research Associate at UCLA’s Center for the Study of Women (2010-2011). He has published papers in anthologies, such as Dead History, Live Art and Art &amp; Shame, and academic journals.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LT`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Laurel Taylor`}
                        </h2>
                        <p>
                            {t`Dr. Laurel Taylor received her Ph.D. in the Art and Archaeology of the Mediterranean World from the University of Pennsylvania and teaches in the Departments of Art and Classics at the University of North Carolina Asheville. Her research interests focus on funerary art and ritual in ancient Italy and exploring the social meaning of death through Etruscan and Roman visual culture. Her current fieldwork is at the Etruscan and Roman site of Cetamura del Chianti, Italy.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RT`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Rebecca Taylor`}
                        </h2>
                        <p>
                            {t`Rebecca Taylor has more than a decade of experience in arts communications, having led communications campaigns &amp; initiatives at several world-renowned museums (MoMA PS1, the Getty, and MOCA), before joining FITZ &amp; CO. She received an M.A. in Modern Art, Connoisseurship and the Art Market from Christie’s, New York.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`ST`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Susanna Throop`}
                        </h2>
                        <p>
                            {t`Dr. Susanna Throop studies the cultural intersection of religion, violence, ideology, and emotion in twelfth and thirteenth century Europe, especially in the context of the crusading movement. She holds a Ph.D. in History from the University of Cambridge, where she was a Gates Cambridge Scholar. Previously she earned an M.A. as a Mellon Fellow at the University of Toronto. Currently she is an Assistant Professor of History at Ursinus College.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`VV`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Victoria Valdes`}
                        </h2>
                        <p>
                            {t`Victoria Valdes is studying at the University of Virginia as a candidate for the Ph.D. in the History of Art and Architecture. She works primarily with early medieval manuscripts, specializing in the Ottonian period.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Rachel Warriner`}
                        </h2>
                        <p>
                            {t`Rachel Warriner is currently a Ph.D. candidate in the Art History Department at University College Cork, Ireland. Her research focuses on post-war feminist practice. She received a BA (Hons) in Theatre from Dartington College of Art, Devon, UK in 2002 and has since been co-editor of DEFAULT magazine, and has published a number of papers and reviews on post war art and performance.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`JW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Jessica Watson`}
                        </h2>
                        <p>
                            {t`Jessica Watson received her MA in Art History from the École du Louvre in Paris where she worked on propagandist photomontage in the USSR.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Kendra Weisbin`}
                        </h2>
                        <p>
                            {t`Kendra Weisbin has a Master's degree in Art History from the University of Massachusetts, Amherst, with a concentration in Islamic Art and Architecture. Her most recent projects include an educator’s resource guide to the Islamic collections at the Metropolitan Museum of Art, and a visitor’s walking guide to the same collection, both co-authored with curators from that department.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Charles Wiebe`}
                        </h2>
                        <p>
                            {t`Charles Wiebe is Adjunct Professor of the History of Art and Architecture at the Art Institute of Pittsburgh. He earned an MA in the History of Art &amp; Architecture from the Pennsylvania State University, with dissertation research on American and Italian Renaissance architecture. He has lectured at the University of Pittsburgh as well as Point Park University and serves as Subject Matter Expert on art at the University of Phoenix, where he has also taught film studies.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Kathryn Wolford`}
                        </h2>
                        <p>
                            {t`Dr. Kathryn Wolford received a Ph.D. in History from Claremont Graduate University. Her research and teaching interests concern the symbiotic relationships between the Protestant Reformation, the Scientific Revolution, and the political revolutions within Europe and the wider Atlantic world during the sixteenth and seventeenth centuries. She is a reader at the Huntington Library and has taught at the University of California, Riverside, and Harvey Mudd College.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`LW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Louisa Woodville`}
                        </h2>
                        <p>
                            {t`Louisa Woodville teaches at George Mason University where she specializes in medieval and Renaissance art history, focusing in the social, economic and political context in which artists created works. After receiving an M.A. in Renaissance Studies from the University of Virginia and an M.B.A. from the Stern School of Business at New York University, Louisa worked at the Metropolitan Museum in New York and the Manhattan auction house William Doyle Galleries.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CZ`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Christine Zappella`}
                        </h2>
                        <p>
                            {t`Christine Zappella is a doctoral student in Art History at the University of Chicago and holds Master’s degrees in both Art History from CUNY Hunter College and Teaching (Math Concentration) from Pace University. Christine focuses on sixteenth century Italian painting.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`FA`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Faris Al Ahmad`}
                        </h2>
                        <p>
                            {t`Faris Al Ahmad received an MA in Middle Eastern Studies from The Graduate Center, City University of New York. His research interests include Islamic history and cultures, contemporary Islamic thought. He is also a lecturer of Arabic language at Hunter College, CUNY. `}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`KC`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Kristen Chiem`}
                        </h2>
                        <p>
                            {t`Kristen is Contributing Editor for East Asian Art. She earned her M.A. from Harvard University and her Ph.D. from the University of California, Los Angeles. Her research concentrates on late imperial Chinese painting. She is currently Assistant Professor of Art History at Pepperdine University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EF`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Elisa Foster`}
                        </h2>
                        <p>
                            {t`Elisa specializes in late Medieval and early modern French art and architecture. She received her PhD from Brown University and has taught at Paris College of Art, Southern Methodist University and the University of Texas at Arlington, among others. Beginning in January, she will be a Lecturer in the John V. Roach Honors College at Texas Christian University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Ellen Hurst`}
                        </h2>
                        <p>
                            {t`Ellen earned her PhD at the Graduate Center, CUNY. Her research addresses cultural interaction in the early modern world, with a focus on the exchange between northern Italy and Muscovy in the sixteenth century. She has taught art history in the Midwest and on the East Coast, and currently works as a consulting writer, editor, and researcher for several major arts organizations, including the Metropolitan Museum of Art and the US State Department’s Art in Embassies Program.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`RK`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Rex Koontz`}
                        </h2>
                        <p>
                            {t`Rex Koontz is contributing editor for Pre-Columbian art in Mesoamerica. Rex is an art historian who works in the museum collections and archaeological sites of Mexico. He has written extensively on the ancient history of Mexico, including the recent Lightning Gods and Feathered Serpents: The Public Sculpture of El Tajin (2009, University of Texas Press). He is also the author (with Michael Coe) of Mexico: From the Olmecs to the Aztecs, the standard English introduction to the history of Ancient Mexico. He was recently one of three North Americans asked to contribute to the celebration of Mexico’s Bicentenary at the National Museum of Anthropology and History, Mexico City. He is currently Professor of Art History and Director of the School of Art, University of Houston.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`CBM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Claire Black McCoy`}
                        </h2>
                        <p>
                            {t`Claire is the William B. and Sue Marie Turner Distinguished Faculty Chair in Art History at Columbus State University. She was previously Associate Professor of Art History at Longwood University in Virginia, where she received the Maria Bristow Starke Faculty Excellence Award for outstanding teaching and research and served as Director of General Education. Dr. McCoy received her Ph.D. from Virginia Commonwealth University and specializes in nineteenth-century interpretations of Renaissance artists and their impact on the reception and criticism of sculpture in France.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`OM`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Olivia Miller`}
                        </h2>
                        <p>
                            {t`Olivia received her M.A. in Art History from the University of Oregon with a focus on the Spanish royal hunting portrait tradition. She is currently an art history Ph.D. student and the Curator of Exhibitions and Education at the University of Arizona Museum of Art. Prior to her position at UAMA she taught art history at both the high school and college level and worked at multiple non-profit arts organizations in both Oregon and Arizona.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`EN`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Erika Nelson`}
                        </h2>
                        <p>
                            {t`Erika Nelson has an MA in Art History from Brooklyn College, and is a doctoral student in Art History at The Graduate Center, CUNY. Her area of specialization is modern and contemporary Latin American Art, with a particular interest in 19th-century Mexican popular prints. Erika currently teaches at Montclair State University in New Jersey.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Melissa Palermo`}
                        </h2>
                        <p>
                            {t`Melisa is a Ph.D. candidate in art history at Rice University. She received her Masters in art history from the University of Texas at San Antonio as well as from Rice University. Melisa’s primary interest is the relationship between Baroque sacred art and theology, spirituality, and mysticism. Her dissertation focuses on the iconography of the heart aflame as a symbol of the virtue of charity, divine union, and the Sacred Heart of Jesus in art from 1550-1750.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`AP`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Andreas Petzold`}
                        </h2>
                        <p>
                            {t`Andreas was educated at Manchester University and the Courtauld Institute of Art where he obtained a Ph.D. for a study of color in Romanesque manuscript illumination. He was a curator at the Victoria and Albert Museum, where he specialized in Medieval and Renaissance art. He is the author of Romanesque art in the Everyman Art Series. He currently teaches at MPW London and is an Associate Lecturer for the Open University. He is currently working on a study of the iconography of color in Medieval art due for publication in 2016.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MR`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Melody Rod-ari`}
                        </h2>
                        <p>
                            {t`Melody is Contributing Editor for Southeast Asian art. She earned her M.A. from Boston University and her Ph.D. from the University of California, Los Angeles. Her research examines modern and contemporary Thai Buddhist visual culture. She is currently Assistant Curator of Asian art at the Norton Simon Museum and Editor for the American Council for Southern Asian Art. Beginning in August she will join the faculty of art history at Loyola Marymount University. `}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`SS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Sarahh Scher`}
                        </h2>
                        <p>
                            {t`Sarahh is a Contributing Editor for Pre-Columbian South American Art. She received her Ph.D. in art history from Emory University and an M.F.A. in printmaking from New Mexico State University. Her research focuses on issues surrounding the representation of gender, identity, and costume in the Andean area. She teaches part-time at Salem State University.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`MS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Malka Simon`}</h2>
                        <p>
                            {t`Malka Simon holds a PhD from the Institute of Fine Arts, NYU in art history. She specializes in 19th- and 20th-century architecture and urban development of the United States, with a particular focus on New York City. Her most recent work addresses the role of industrial architecture in shaping urban landscapes.  She is a Lecturer in the Art Department at Brooklyn College.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`FW`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Dr. Fanny Wonu Veys`}
                        </h2>
                        <p>
                            {t`Dr. Fanny Wonu Veys received her PhD in the anthropology of material culture at the University of East Anglia, Norwich (UK), and completed post-doctoral research at the Metropolitan Museum of Art, New York (USA) and the Musée du quai Branly, Paris (France). She is currently curator Oceania at the National Museum of World Cultures (Tropenmuseum, Afrika Museum and Museum Volkenkunde) in the Netherlands. She is an affiliated researcher in an Australian Research Council photographic project and a European Research Council focusing on Oceanian collecting histories. Wonu’s research interests are Pacific art and material culture, museums and cultures of collecting, Pacific musical instruments, Pacific textiles, and the significance of historical objects in a contemporary setting.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`NH`}</div>
                    <div className="card-info">
                        <h2 className="pulls">
                            {doNotTranslate`Nathalie N. Hager`}
                        </h2>
                        <p>
                            {t`Nathalie N. Hager is a Ph.D. candidate in the Interdisciplinary Graduate Studies program at the University of British Columbia’s Okanagan campus. She is writing her dissertation on World Art History, a turn in the discipline away from national histories and area studies towards modes that foreground connection and exchange, and how its discourse is developing in art historical theory and scholarship, museums, and pedagogy.`}
                        </p>
                    </div>
                </div>

                <div className="team-card">
                    <div className="card-photo card-initials">{t`HS`}</div>
                    <div className="card-info">
                        <h2 className="pulls">{doNotTranslate`Hung Sheng`}</h2>
                        <p>
                            {t`Hung Sheng is currently a PhD candidate in the Department of Visual Studies at Lingnan University, Hong Kong. Her research interests are the history and aesthetics of twentieth century Chinese and Hong Kong art as well as art education in different settings. She received a BA (Hons) (2011) and MPhil in Visual Studies (2013) at Lingnan University. Her MPhil focused on the art of Irene Chou as a case study of Hong Kong Ink Painting.`}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );

    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`About Our Content Specialists`}}>
                <div className="about-page">
                    <AboutHeader
                        pageheadline={t`Meet Our Content Specialists.`}
                        headercontent={
                            <a href="/careers" className="apply-button">
                                {t`Apply now`}
                            </a>
                        }
                    />
                    <AboutNav aboutSelection="our-content-specialists" />
                    <div
                        id="content-specialists"
                        style={styles.contentSpecialists}
                    >
                        {this.renderSearchBar()}
                        {this.renderEmeritusFaculty()}
                        {this.renderMath()}
                        {this.renderPhysicalSciences()}
                        {this.renderHumanities()}
                        {this.renderTestPrep()}
                        {this.renderHealthAndMedicine()}
                        {this.renderArtAndHistory()}
                    </div>
                </div>
            </PageRoot>
        );
    }
}

const styles = StyleSheet.create({
    contentSpecialists: {
        fontSize: "14px",
    },
});

type ExportProps = WithoutActionScheduler<
    JSX.LibraryManagedAttributes<
        typeof OurContentSpecialists,
        React.ComponentProps<typeof OurContentSpecialists>
    >
>;
export default withStrings(
    withActionScheduler(
        OurContentSpecialists,
    ) as React.ComponentType<ExportProps>,
);
